module.exports = __webpack_public_path__ + "static/typography-mix-typefaces-dont-6d919607982b8d5887e717a45aa3c80f.png";